<template>
  <div
    class="download-qr-link"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <slot></slot>
    <div v-if="showPopover && safeHref" class="qr-popover">
      <div class="qr-title">{{ localizedQrTitle }}</div>
      <div class="qr-content">
        <img
          v-if="qrDataUrl"
          :src="qrDataUrl"
          :alt="localizedQrTitle"
          class="qr-image"
        />
        <span v-else class="qr-loading">{{ localizedLoadingText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";

export default {
  name: "DownloadQrLink",
  props: {
    href: {
      type: String,
      default: "",
    },
    qrTitle: {
      type: String,
      default: "",
    },
    loadingText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showPopover: false,
      qrDataUrl: "",
      isGenerating: false,
    };
  },
  computed: {
    safeHref() {
      return this.href || "";
    },
    localizedQrTitle() {
      return this.qrTitle || this.$t("m100.download_qr_title");
    },
    localizedLoadingText() {
      return this.loadingText || this.$t("m100.download_qr_loading");
    },
  },
  methods: {
    async handleMouseEnter() {
      this.showPopover = true;
      if (this.qrDataUrl || this.isGenerating || !this.safeHref) {
        return;
      }
      this.isGenerating = true;
      try {
        this.qrDataUrl = await QRCode.toDataURL(this.safeHref, {
          width: 132,
          margin: 1,
        });
      } catch (error) {
        // 二维码生成失败时仅输出日志，避免影响下载主流程
        console.error("生成下载二维码失败:", error);
      } finally {
        this.isGenerating = false;
      }
    },
    handleMouseLeave() {
      this.showPopover = false;
    },
  },
};
</script>

<style scoped>
.download-qr-link {
  position: relative;
  display: inline-block;
}

.qr-popover {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  padding: 10px;
  z-index: 20;
  white-space: nowrap;
}

.qr-title {
  font-size: 12px;
  color: #666666;
  text-align: center;
  margin-bottom: 8px;
}

.qr-content {
  width: 132px;
  height: 132px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-image {
  width: 132px;
  height: 132px;
  display: block;
}

.qr-loading {
  font-size: 12px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadQrLink.vue